import GradesTableWrapper, { GradesTable } from './GradesTable';

export { GradesTable };

export default GradesTableWrapper;
